const ITEMS = [
  "VANNIN INDEPENDENT APPAREL",
  "ELLAN VANNIN — ISLE OF MAN",
  "PERSONALLY HANDLED, EVERY ORDER",
  "SOURCED TO ORDER • NO WASTE",
  "SECURE CARD PAYMENTS",
  "FROM THE ISLAND TO THE WORLD",
];

function TriskelionDot() {
  return (
    <svg width="16" height="16" viewBox="0 0 100 100" className="shrink-0">
      <g fill="none" stroke="#E52E39" strokeWidth="10" strokeLinecap="round">
        {[0, 120, 240].map((r) => (
          <path key={r} d="M50 50 C 46 32, 58 16, 78 22" transform={`rotate(${r} 50 50)`} />
        ))}
      </g>
    </svg>
  );
}

export default function Marquee() {
  const row = (hidden) => (
    <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="px-8 font-display text-2xl font-bold uppercase tracking-wide text-stone-300 md:text-4xl">
            {item}
          </span>
          <TriskelionDot />
        </span>
      ))}
    </div>
  );
  return (
    <div className="relative overflow-hidden border-y border-stone-200 bg-[#FAF8F4] py-5">
      <div className="marquee-track">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
}
